// 添加或编辑承保记录
import request from "@/utils/request";


// 获取钉钉对接问题
export const getDingTalkIssue = (data: any) => {
  return request.post("/api/v2/carSaveInfo/list", data);
};